import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { TuiSheetModule, TuiSheetOptions } from '@taiga-ui/addon-mobile';
import { TuiButtonModule, TuiSvgModule } from '@taiga-ui/core';
import { CartActions } from '@us/web/cart/data-access';
import { FormattedAddressPipe, Order, OrderType } from '@us/web/shared/data-access';
import { CardComponent, SelectTimeComponent } from '@us/web/shared/ui';
import { RouteUtil } from '@us/web/shared/utils';
import { FormatPipeModule, ParseIsoPipeModule } from 'ngx-date-fns';
import { formatISO } from 'date-fns';
import { ShipmentDetailsComponent } from '../shipment-details/shipment-details.component';
import { selectRequiredToLogin } from '@us/web/shop/data-access';

@Component({
    selector: 'us-order-shipping-details',
    standalone: true,
    imports: [
        TranslocoModule,
        IonicModule,
        TuiSvgModule,
        RouterLink,
        FormattedAddressPipe,
        NgIf,
        FormatPipeModule,
        ParseIsoPipeModule,
        TuiSheetModule,
        SelectTimeComponent,
        CardComponent,
        ShipmentDetailsComponent,
        TuiButtonModule
    ],
    templateUrl: './order-shipping-details.component.html',
    styleUrls: ['./order-shipping-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderShippingDetailsComponent {
    @Input() order!: Order;
    @Input() readonly = false;

    private readonly router = inject(Router);
    private readonly store = inject(Store);
    private readonly cdr = inject(ChangeDetectorRef);

    readonly allowLogin = this.store.selectSignal(selectRequiredToLogin);

    readonly OrderType = OrderType;
    readonly options: Partial<TuiSheetOptions> = {
        overlay: true,
        closeable: false
    };

    openPickupTimeSheet = false;

    readonly now = formatISO(new Date());

    async handleSelectReceiver() {
        if (this.readonly) {
            return;
        }

        await this.router.navigate([RouteUtil.getSelectDeliveryAddressRouteUrl()], {
            queryParams: { returnUrl: this.router.url },
            queryParamsHandling: 'merge'
        });
    }

    showPickupTimeSheet() {
        if (this.readonly) {
            return;
        }
        this.openPickupTimeSheet = true;
    }

    handleSelectPickupTime(booking_time: string) {
        this.store.dispatch(CartActions.updateCart({ booking_time }));
        this.openPickupTimeSheet = false;
        this.cdr.detectChanges();
    }
}
